"use client";

import { useMutation } from "@tanstack/react-query";
import { trackEvent } from "@/analytics";
import { logException } from "@/analytics/sentry";

interface HideComedianParams {
  comedianId: string;
  location?: string;
  onHide?: (comedianId: string) => void;
}

export function useHideComedian() {
  const mutation = useMutation({
    mutationFn: async ({
      comedianId,
      location,
      onHide,
    }: HideComedianParams) => {
      const res = await fetch(`/api/v2/user/hidden-comedians/${comedianId}`, {
        method: "POST",
      });

      if (!res.ok) {
        throw new Error(`Failed to hide comedian: ${res.statusText}`);
      }

      trackEvent("FEED_HIDE_COMEDIAN", {
        comedian_id: comedianId,
        location,
      });

      if (onHide) {
        onHide(comedianId);
      }

      return res;
    },
    onError: (error, variables) => {
      logException(error, {
        extra: {
          message: "Error hiding comedian",
          comedianId: variables.comedianId,
          location: variables.location,
        },
      });
      console.error("Failed to hide comedian", error);
    },
  });

  return {
    hideComedian: mutation.mutate,
    hideComedianAsync: mutation.mutateAsync,
    isHiding: mutation.isPending,
    error: mutation.error,
  };
}
